import { useDispatch } from 'react-redux';
import styles from './CartItem.module.scss';
import { removeItemFromCart } from '../../../redux/CartSlice';
import { Text } from '../../../shared/ui/Text/Text';
import { closeIcon } from '../../../shared/assets/svg/closeIcon';
import { Button } from '../../../shared/ui/Button/Button';



const CartItem = ({cartItem}) => {

    const dispatch = useDispatch();
    return(
        <div className={styles.content}>                    
            <Text  size='m' className={styles.text__left}>{cartItem.dent.serviceName}</Text>
            <Text size='m' className={styles.text}>{cartItem.quantity}</Text>
            <Text size='m' className={styles.text}>{cartItem.dent.price*cartItem.quantity}</Text>
        <div>
            <Button className={styles.btn} onClick={() => dispatch(removeItemFromCart({cartItemId : cartItem.id}))}>  
                    {closeIcon()}
            </Button> 
        </div>
    </div>
    )
}
 
export default CartItem;